
import { api_host, api_auth} from '../../common/globals/constants';


export const getLastStatusObjective = (objetivo_id, id_user, token) => fetch(api_host+`/reporte/online/indicadores/lastAvailabilityAndResponseObjective/?user=${id_user}&objetivoId=${objetivo_id}&token=${token}`)
.then(response => response.json())
